import axios, { type AxiosError, type AxiosResponse } from "axios";
import type { EnterpriseAppVersion } from "shared/types";
import { apiErrorHandler } from "utilz/helpers";

const publicAxiosClient = axios.create({
  baseURL: import.meta.env["VITE_APP_BASE_URL"],
});

type AgentDownloadLinkResponse = {
  success: boolean;
  data: string;
  is_enterprise?: boolean;
  message?: string;
};

export const getAgentDownloadLink = async ({
  platform,
  type,
  mspId,
}: {
  platform: string;
  type: string;
  mspId: string;
}) => {
  try {
    const response = await publicAxiosClient.get<AgentDownloadLinkResponse>(
      "v2/desktop/download",
      { params: { msp_id: mspId, platform, type } },
    );
    const resData = response?.data;
    if (resData?.success && resData?.data) {
      return resData;
    }
    throw response;
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};

export const getLatestEnterpriseApp = async (
  mspId: string,
): Promise<EnterpriseAppVersion | undefined> => {
  try {
    const url = `/agent/enterprise/latest-version/${mspId}`;
    const response = await publicAxiosClient.get(url);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error) {
    // biome-ignore lint/suspicious/noExplicitAny: error is any
    apiErrorHandler(error as any);
  }
};
